export default "__VITE_ASSET__c0c2d3cc__"